import React from 'react'
import { Input, Typography } from 'antd'
import { useFormikContext } from 'formik'
import { displayAmount } from '../utils/formatter'

const { Text } = Typography
type Props = {
  name: string
  placeholder?: string
}

export const Amount: React.FunctionComponent<Props> = ({
  name,
  placeholder,
}) => {
  const { values, setFieldValue } = useFormikContext<any>()

  const handleChange = (event: any): void => {
    const value: string = event.target.value as string
    setFieldValue(name, prepareAmount(value))
  }

  const displayValue = (value: string): string => {
    return displayAmount(prepareAmount(value))
  }

  const prepareAmount = (value: string): string => {
    const amount: number = parseFloat(value.replace(/\s/g, '')) || 0
    return amount.toString()
  }

  return (
    <Input
      name={name}
      placeholder={placeholder}
      value={displayValue(values[name])}
      onChange={handleChange}
      addonAfter={<Text disabled>рублей</Text>}
    />
  )
}
